export default __webpack_public_path__ + "static/media/keyboard.a6860d33.png";